// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAa5vqUbrSk1hkGmz1gLHDl6ZKPz37yEXA",
  authDomain: "pitstopromantico-99faa.firebaseapp.com",
  projectId: "pitstopromantico-99faa",
  storageBucket: "pitstopromantico-99faa.firebasestorage.app",
  messagingSenderId: "525648323418",
  appId: "1:525648323418:web:59fba6e45fca0e1c7f0963",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app)